module.exports = new __parcel__URL__("ox.0ed06fd3.svg").toString();